import { BrowserRouter } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ProveedoresProvidersPage from "./components/layout/ProveedoresProvidersPage";
import { RequestProvider } from "./context/RequestContext";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import { TokenProvider } from "./context/TokenContext";
import { es } from "date-fns/locale";
import { routeBase } from "./settings/routerConfig";
import { theme } from "./settings/themeConfig";

function App() {
    return (
        <BrowserRouter basename={routeBase}>
            <ThemeProvider theme={theme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                    <TokenProvider>
                        <RequestProvider>
                            <ProveedoresProvidersPage />
                        </RequestProvider>
                    </TokenProvider>
                </MuiPickersUtilsProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
